import React, { useEffect, useState } from 'react';
import { UsuariosAdapter } from '../../../../../../../infraestructure/persistence/rest/UsuariosAdapter';
import { useNotifications } from '../../../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../../../shared/utils/error';
import { AjusteDobleRetencionScreen } from './screen';


export const AjusteExpatriadoDobleRetencion = (props:any)=>{

    const {selected,filter, handleRefreshStateUsers,savePermission} = props;
    const api:any = new UsuariosAdapter();
	const {resultError, exceptionError, launchNotification} = useNotifications();

	const [data,setData] = useState<any>(undefined)
	let [isLoading, setIsLoading] = useState<boolean>(false);
	let result: any;

    useEffect(()=>{
        if(selected!==undefined){
        const request = {anio:filter.anio,mes:Number(filter.mes),tipo:filter.tipo,idEmpleado:selected.idEmpleado,esObra:filter.esObra}
        AjustesCostosExpatriados(request)
        }
    },[selected])

    const AjustesCostosExpatriados = async(request:any) =>{
        setIsLoading(true);
        try {
            result = await api.AjustesCostosExpatriados(request);
            if(result.data && result.data!=="")
                {
            setData({...result.data});
            }else{resultError()}
            setIsLoading(false);
        } catch (error) {
            let exception = ServerErrorMessage(error);
            exceptionError(exception)
            setIsLoading(false);
        }
    }

    const GuardarAjuste = async(ajustes:any) =>{
        const request = {anio:filter.anio,mes:Number(filter.mes),tipo:filter.tipo,idEmpleado:selected.idEmpleado,empresa:data.empresa}
        //setIsLoading(true);
        try {
            result = await api.GuardarAjusteCostoExpatriado([{...request,...ajustes}]);
            if(result.data && result.data!=="")
            {
                setData({...result.data});
                launchNotification({type:"success",title:"Ajustes Costos",message:"Ajustes generados correctamente."})
                handleRefreshStateUsers({...selected,...{ajuste:true}});
            }else{resultError()}
            //setIsLoading(false);
        } catch (error) {
            let exception = ServerErrorMessage(error);
            exceptionError(exception)
            //setIsLoading(false);
        }
    }

    const EliminarAjuste = async()=>{
        const _empresa = data.empresas[0].empresa;
        const request = {anio:filter.anio,mes:Number(filter.mes),tipo:filter.tipo,idEmpleado:selected.idEmpleado,empresa:_empresa}
        try {
            result = await api.EliminarAjusteCostoExpatriado([{...request}]);
            if(result.data && result.data!=="")
            {
                setData({...result.data});
                launchNotification({type:"success",title:"Ajustes Costos",message:"Se ha eliminado el ajuste correctamente."})
                handleRefreshStateUsers({...selected,...{ajuste:false}});
            }else{resultError()}
        } catch (error) {
            let exception = ServerErrorMessage(error);
            exceptionError(exception)
        }
    }


return <AjusteDobleRetencionScreen data={data} selected={selected} savePermission={savePermission} handleSave={GuardarAjuste} handleDelete={EliminarAjuste} isLoading={isLoading}/>
}